import { Contact, ContactPerson } from '@repo/types';
import { toE164 } from 'src/utils/phone';
import { EnhancedConversionCustomer } from './events.types';

export function contactPersonToCustomer(
    cp: ContactPerson | null | undefined,
): EnhancedConversionCustomer | undefined {
    if (!cp) return undefined;
    return {
        email: cp.email || undefined,
        phoneNumber: toE164(cp.phone?.dialCode, cp.phone?.number),
        firstName: cp.firstName || undefined,
        lastName: cp.lastName || undefined,
        address: {
            street: cp.address || undefined,
            city: cp.city || undefined,
            postalCode: cp.postCode || undefined,
            country: cp.country || undefined,
        },
    };
}

export function contactContentToCustomer(
    c: Contact['content'] | null | undefined,
): EnhancedConversionCustomer | undefined {
    if (!c) return undefined;
    return {
        email: c.email || undefined,
        phoneNumber: toE164(c.phonePrefix, c.phone),
        firstName: c.firstName || undefined,
        lastName: c.surname || undefined,
        address: {
            street: c.address || undefined,
            city: c.location || undefined,
            postalCode: c.zipcode || undefined,
            country: c.country || undefined,
        },
    };
}
